<!--有奖竞答-->
<template>
  <div :class="[isPc ? 'guess-container-pc' : 'guess-container']">
    <div class="cm-guess-p rule-p">
      <div class="cm-guess-title">{{ content.activityRule }}</div>
      <div class="rule-content">
        <p>知识竞答规则（线上答题仅在云ICU直播平台进行）：</p>
        <p>1.共两个答题环节，线上线下均可答题，每个环节答题时间限时1分钟。</p>
        <p>2.线上答题仅在云ICU直播平台进行，开始答题时，云ICU直播平台将会直接弹出答题框。</p>
        <p>3.现场嘉宾请扫码答题，扫码后录入姓名及电话号码后开始答题。</p>
        <p>4.每个环节回答正确且用时最短的前三名，将获得神秘礼品一份，现场嘉宾请于会后领奖，线上答题获奖者的礼品将于会后寄出。</p>
        <p>5、中奖后需填写收货地址，手机端点击底部加号---个人资料---完善收货地址，PC电脑端点击右上角头像---个人资料---完善收货地址</p>
      </div>
    </div>
    <div class="cm-guess-p winner-p">
      <div class="cm-guess-title">{{ content.winnersList }}</div>
      <div class="winner-content">
        <div v-for="(item, index) in winnerList" :key="index" class="winner-item">
          <div class="winner-item-title">
            <span class="badge">[{{ item.question_title }}]</span>
            <span v-for="(item1, index1) in item.question_list" :key="index1" class="title-content">正确答案{{ index1 + 1 }} {{ item1 }}</span>
          </div>
          <div v-for="(item2, index2) in item.answers" :key="index2" class="winner-item-content">
            {{ item2.time }} {{ item2.name }} {{ item2.hospital }}
          </div>
        </div>
      </div>
    </div>
    <div class="cm-guess-p parti-p">
      <div class="cm-guess-title">{{ content.participantsList }}</div>
      <div class="parti-content">
        <div v-for="(item, index) in partiList" :key="index" class="parti-item">
          <span class="parti-item-content">{{ item.time }}</span>
          <span class="parti-item-content">{{ item.name }}</span>
          <span class="parti-item-content">{{ item.hospital }}</span>
          <span class="badge">[{{ item.question }}]</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { winningList, participantList } from '@/models/common'
export default {
  props: {
    streamId: {
      // 	直播会议ID
      type: Number,
      default: null
    }
  },
  data() {
    return {
      winnerList: [],
      partiList: []
    }
  },
  computed: {
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc'])
  },
  mounted() {
    this.reloadData()
  },
  methods: {
    reloadData() {
      this.getWinnerList()
      this.getPartiList()
    },
    // 获取中奖名单
    getWinnerList() {
      winningList({
        live_stream_id: this.streamId
      }).then((res) => {
        if (res.data.code == 0) {
          const list = res.data.data
          let obj = {}
          for (let i = 0; i < list.length; i++) {
            if (obj[list[i].question_id]) {
              obj[list[i].question_id].answers.push({
                name: `${list[i].member_name.slice(0, 1)}*${list[i].member_name.length > 2 ? list[i].member_name.slice(-1) : ''}`,
                time: `${list[i].created_time.slice(11, 19)}`,
                hospital: list[i].hospital_name
              })
            } else {
              obj[list[i].question_id] = {
                question_id: list[i].question_id,
                question_title: list[i].question_title,
                question_list: list[i].question_list.map((item) => item.result).flat(),
                answers: [
                  {
                    name: `${list[i].member_name.slice(0, 1)}*${list[i].member_name.length > 2 ? list[i].member_name.slice(-1) : ''}`,
                    time: `${list[i].created_time.slice(11, 19)}`,
                    hospital: list[i].hospital_name
                  }
                ]
              }
            }
          }
          this.winnerList = Object.values(obj)
        }
      })
    },
    // 获取参与名单
    getPartiList() {
      participantList({
        live_stream_id: this.streamId
      }).then((res) => {
        if (res.data.code == 0) {
          this.partiList = res.data.data.map((item) => {
            return {
              name: `${item.member_name.slice(0, 1)}*${item.member_name.length > 2 ? item.member_name.slice(-1) : ''}`,
              time: `${item.show_time}`,
              hospital: item.hospital_name,
              question: item.question
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.guess-container-pc {
  padding: 0.15rem 0.1rem;
  background-color: #222328;
  height: 100%;
  color: #FFF;
  overflow-y: auto;
  .cm-guess-p {
    background-color: #484848;
    border-radius: 0.05rem;
    padding: 0.15rem;
    .cm-guess-title {
      border-left: 0.1rem solid #ff9c00;
      font-size: 0.2rem;
      padding-left: 0.15rem;
      color: #ffae34;
    }
  }
  .cm-guess-p + .cm-guess-p {
    margin-top: 0.15rem;
  }
  .rule-content {
    font-size: 0.18rem;
    padding: 0.1rem;
    line-height: 1.6;
  }
  .winner-content {
    font-size: 0.18rem;
    padding: 0.1rem;
    line-height: 1.6;
    .winner-item {
      .winner-item-title {
        margin-top: 0.1rem;
        .badge {
          color: #ff9c00;
          margin-right: 0.1rem;
        }
        .title-content {
          padding-right: 0.1rem;
        }
      }
      .winner-item-content {
        margin-top: 0.05rem;
      }
    }
  }
  .parti-content {
    font-size: 0.18rem;
    padding: 0.1rem;
    line-height: 1.6;
    .parti-item {
      margin-top: 0.05rem;
      .parti-item-content + .parti-item-content {
        padding-left: 0.1rem;
      }
      .badge {
        margin-left: 0.1rem;
        color: #ff9c00;
      }
    }
  }
}
.guess-container {
  padding: 0.15rem 0.1rem;
  background-color: #f4f4f4;
  height: 100%;
  overflow-y: auto;
  .cm-guess-p {
    background-color: #fff;
    border-radius: 0.05rem;
    padding: 0.15rem;
    .cm-guess-title {
      border-left: 0.1rem solid #ff9c00;
      font-size: 0.18rem;
      padding-left: 0.15rem;
      color: #ffae34;
    }
  }
  .cm-guess-p + .cm-guess-p {
    margin-top: 0.15rem;
  }
  .rule-content {
    font-size: 0.16rem;
    padding: 0.1rem;
    line-height: 1.6;
  }
  .winner-content {
    font-size: 0.16rem;
    padding: 0.1rem;
    line-height: 1.6;
    .winner-item {
      .winner-item-title {
        margin-top: 0.1rem;
        .badge {
          color: #ff9c00;
          margin-right: 0.1rem;
        }
        .title-content {
          padding-right: 0.1rem;
        }
      }
      .winner-item-content {
        margin-top: 0.05rem;
      }
    }
  }
  .parti-content {
    font-size: 0.16rem;
    padding: 0.1rem;
    line-height: 1.6;
    .parti-item {
      margin-top: 0.05rem;
      .parti-item-content + .parti-item-content {
        padding-left: 0.1rem;
      }
      .badge {
        margin-left: 0.1rem;
        color: #ff9c00;
      }
    }
  }
}
</style>
